import { ICON_DOCUMENT } from '@global/constants';
import { RoutePaths } from '@global/routePaths';

export const summarySteps = [
  {
    id: 'contract',
    title: 'STEPS.THANK_YOU.TITLE',
    iconClass: ICON_DOCUMENT,
    steps: [
      // Confirmation
      {
        title: 'STEPS.SUMMARY.TITLE',
      },
    ],
    route: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DATA.route,
  },
];
